import React from 'react';
import Icon from '../../../components/AppIcon';

const LeadFunnelVisualization = ({ stages }) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
          Sales Funnel Visualization
        </h2>
        <Icon name="Filter" size={20} className="text-gray-400" />
      </div>

      <div className="space-y-4">
        {stages?.map((stage, index) => (
          <div key={index} className="relative">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-3">
                <span className="text-sm font-medium text-gray-900 dark:text-white">
                  {stage?.stage}
                </span>
                <span className="text-xs text-gray-500 dark:text-gray-400">
                  {stage?.leads} leads
                </span>
              </div>
              <span className="text-sm font-semibold text-gray-900 dark:text-white">
                {stage?.percentage}%
              </span>
            </div>
            
            <div className="w-full bg-gray-200 dark:bg-slate-700 rounded-full h-8 overflow-hidden">
              <div
                className={`h-full ${stage?.color} transition-all duration-500 flex items-center justify-end pr-3`}
                style={{ width: `${stage?.percentage}%` }}
              >
                <span className="text-xs font-medium text-white">
                  {stage?.leads}
                </span>
              </div>
            </div>
            
            {index < stages?.length - 1 && (
              <div className="flex justify-center my-2">
                <Icon name="ChevronDown" size={16} className="text-gray-400" />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700">
        <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
          <Icon name="Info" size={16} />
          <span>Stage progression rates calculated from last 30 days</span>
        </div>
      </div>
    </div>
  );
};

export default LeadFunnelVisualization;